import { TranslationMap } from '@trimble-gcs/i18n-types';

export function taggingTranslations() {
  return {
    title: {
      text: $localize`:@@multiSelectedTagging.title:Edit Tags`,
      desc: 'Title of the multi-select tag edit panel.',
    },
    close: {
      tooltip: {
        text: $localize`:@@multiSelectedTagging.close.tooltip:Close`,
        desc: 'Tooltip for the top right "X" button that closes the multi-select tag edit panel.',
      },
    },
    remove: {
      text: $localize`:@@multiSelectedTagging.remove:Remove Existing Tags`,
      desc: 'Section header text for the current list of tags, of which can be be removed.',
    },
    add: {
      text: $localize`:@@multiSelectedTagging.add:Add Tags`,
      desc: 'Section header text for the current list of tags being added.',
    },
    tagInput: {
      placeholder: {
        text: $localize`:@@multiSelectedTagging.tagInput.placeholder:Begin typing to search...`,
        desc: 'Placeholder text for the tag input field.',
      },
      lengthExceededError: {
        text: $localize`:@@multiSelectedTagging.tagInput.lengthExceededError:Maximum {maxCharacters} characters allowed.`,
        desc: 'Error message shown when the tag input exceeds the maximum character length.',
      },
    },
    cancel: {
      text: $localize`:@@multiSelectedTagging.cancel:Cancel`,
      desc: 'Button text to discard changes and close the multi-select tag edit panel.',
    },
    save: {
      text: $localize`:@@multiSelectedTagging.save:Save`,
      desc: 'Button text to save the removed or added tags and close the multi-select tag edit panel.',
    },
    selected: {
      text: $localize`:@@multiSelectedTagging.selected:Selected Items`,
      desc: 'Section header text for the selected list of items being edited.',
    },
    saveErrorDialog: {
      title: {
        text: $localize`:@@multiSelectedTagging.saveErrorDialog.title:Save Error`,
        desc: 'Title of the error dialog.',
      },
      message: {
        '=1': {
          text: $localize`:@@multiSelectedTagging.saveErrorDialog.message.one:The following scan failed to update: {names}`,
          desc:
            'Error message shown when a single error occurs while saving the tags. ' +
            '{names} will contain a single item name.',
        },
        other: {
          text: $localize`:@@multiSelectedTagging.saveErrorDialog.message.other:The following scans failed to update: {names}`,
          desc:
            'Error message shown when multiple errors occured while saving the tags. ' +
            '{names} are delimited with a new line.',
        },
      },
      dismiss: {
        text: $localize`:@@multiSelectedTagging.saveErrorDialog.dismiss:Dismiss`,
        desc: 'Button text to dismiss the error dialog.',
      },
    },
  } satisfies TranslationMap;
}
